exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-site-search-2[data-v-9873d616]{display:flex;align-items:center}.vue-site-search-2 .vss-input-group[data-v-9873d616]{margin:0;position:relative;height:100%}.vue-site-search-2 .vss-input-group input[type=search][data-v-9873d616]{padding-right:40px;height:100%;font-size:18px}.vue-site-search-2 .vss-input-group .search-icon[data-v-9873d616]{position:absolute;top:0;right:0;height:100%;width:40px;display:flex;align-items:center;justify-content:center}", ""]);

// exports
